(() => {
  const selector = 'cart-drawer .cart-drawer__close, cart-drawer [data-ref="remove-item"]';

  const applyHuoControlStyle = (root = document) => {
    if (!root.querySelectorAll) return;
    root.querySelectorAll(selector).forEach((button) => {
      button.classList.add('header__mobile-menu-close');
    });
  };

  const init = () => {
    applyHuoControlStyle(document);

    const observer = new MutationObserver(() => applyHuoControlStyle(document));
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
